export default __webpack_public_path__ + "static/media/wave.78f9b14a.svg";